import L from 'leaflet';
import { polygonOnCreatedAction } from '../polygonOnCreatedAction';
import { markerOnCreatedAction } from '../markerOnCreatedAction';
import { polygonOnEditedAction } from '../polygonOnEditedAction';
// import { rectangleOnCreatedAction } from '../rectangleOnCreatedAction';
import { setMultiPolygonEditedID } from '../../../../../../../app/redux/slices/multiPolygonEditedIDSlice';
import { disableEditMode, disableMarker, enableEditMode } from '../../../../../base/functions/base/LeafletBaseFunctions';
import { measureToolOnCreated, polylineOnCreated } from '../measureToolOnCreated';
import { setIsDrawPolygonActiveState } from '../../../../../../../app/redux/slices/isDrawPolygonActiveSlice';
import { sendDataToParent } from '../../../../../base/functions/sendDataToParent';
import {
    setPolylineDistanceTooltipCoords,
    updatePolylineDistanceTooltipCoords,
} from '../../../../../../../app/redux/slices/PolylineDistanceTooltipCoordsSlice';
import { setDeletedLayerIDs } from '../../../../../../../app/redux/slices/deletedLayerIDsSlice';
import { setMapLayers } from '../../../../../../../app/redux/slices/mapLayersSlice';
import { setIsUsingMeasuringTool } from '../../../../../../../app/redux/slices/isUsingMeasuringToolSlice';
import { removeRotationButton } from '../../../../../base/functions/removeMapButtons';
import { rotationControlFunction } from '../../../../../base/controllers/RotationControl/rotationControlFunction';
import { setSquareGridCoordinates } from '../../../../../../../app/redux/slices/squareGridCoordinatesSlice';
import { setGridRegionPolygonCoords } from '../../../../../../../app/redux/slices/gridRegionPolygonCoordinatesSlice';
import {
    setEditDrawnPolygonIdState,
    setIsEditDrawnPolygons,
} from '../../../../../../../app/redux/slices/isEditDrawnPolygonSlice';

import 'leaflet.path.drag';
import { earthEngineAreaOfInterestPolygonCoords } from '../../../../../../../app/redux/slices/earthEngineAreaOfInterestPolygonCoordsSlice';
import { convertPolygonCoordsToLngLatArray } from '../../../../../../../core/utils/map.utils';

export const leafletDrawEditControlEventsFunctions = (
    map,
    mapRef,
    dispatch,
    featureGroupRef,
    mapLayerIDs,
    singlePolygonCoords,
    isUsingMeasuringTool,
    measuringToolDrawn,
    measuringToolCheckToggle,
    multiPolygonEditedId,
    distanceBetweenGeneratedPoints,
    isSlopeServiceActive,
    isEarthEngineServiceActive,
    setIsEditControlMounted,
    setIsMeasuringToolDrawn,
    setMeasuringToolCheckToggle,
    setMeasuringToolLines,
    setMeasuringToolIds,
) => {
    const isUsingGridGeneratorTool = distanceBetweenGeneratedPoints ? true : false;
    return {
        onMounted: (e) => {
            // console.log('onMounted event: ', props.e._toolbars.edit.options.featureGroup.on);
            setIsEditControlMounted(true);
        },
        onDrawStart: (e) => {
            // console.log('draw started: ', e);
            // if (e.layerType === 'polyline') {
            //     sendDataToParent({ type: 'polyline-draw-started' });
            // }
        },
        onDrawStop: (e) => {
            //console.log('DRAW STOP EVENT: ', e);
        },
        onCreated: (e) => {
            // console.log('CREATE EVENT: ', e);
            const { layerType, layer } = e;
            // layer.dragging.enable();
            // console.log('LAYER TYPE: ', layerType);
            if (layerType === 'polygon' && !isUsingGridGeneratorTool) {
                polygonOnCreatedAction(e, dispatch, singlePolygonCoords, map);
            }

            //*will generate a grid inside the drawn polygon*/
            if (layerType === 'polygon' && isUsingGridGeneratorTool) {
                dispatch(setGridRegionPolygonCoords(e.layer._latlngs[0]));
            }

            //*will set area of interest polygon coords for earth engine service*/
            if (layerType === 'polygon' && isEarthEngineServiceActive) {
                console.log('area of interest polygon: ', e.layer._latlngs[0]);
                dispatch(earthEngineAreaOfInterestPolygonCoords(convertPolygonCoordsToLngLatArray(e.layer._latlngs[0])));
            }

            if (isUsingMeasuringTool && layerType === 'polyline') {
                // console.log('measuring ruler created');
                measureToolOnCreated(e, dispatch, setMeasuringToolLines, setMeasuringToolIds, isSlopeServiceActive);
                setIsMeasuringToolDrawn(true);
                setMeasuringToolCheckToggle(!measuringToolCheckToggle);
            }

            if (!isUsingMeasuringTool && layerType === 'polyline') {
                // dispatch(setIsUsingMeasuringTool(false));
                // setIsMeasuringToolDrawn(false);
                // console.log('regular polyline');
            }

            if (layerType === 'marker') {
                markerOnCreatedAction(e);
            }
        },
        onEditStart: (e) => {
            // console.log('EditStart EVENT: ', e);
            map.setBearing(0);
            removeRotationButton();
        },
        onEditMove: (e) => {
            // console.log('EditMove EVENT: ', e);
            map.setBearing(0);
        },
        onEditStop: (e) => {
            // console.log('EditStop Event: ', e);
            sendDataToParent({ type: 'edit-stopped' });
            dispatch(setIsEditDrawnPolygons(false));
            map.setBearing(0);
            rotationControlFunction(map, mapRef, dispatch);
        },
        onEdited: (e) => {
            // console.log('Edited EVENT: ', e);
            dispatch(setIsEditDrawnPolygons(false));
            rotationControlFunction(map, mapRef, dispatch);
            polygonOnEditedAction(e, dispatch, map, multiPolygonEditedId);
        },
        onDeleteStart: (e) => {
            // console.log('ON DELETE START: ', e);
        },
        onDeleteStop: (e) => {
            // console.log('delete stop: ', e);
        },
        onDeleted: (e) => {
            // console.log('DELETED EVENT: ', e);
            const deletedLayerIDs = Object.values(e.layers._layers).map(({ _leaflet_id }) => _leaflet_id);

            if (multiPolygonEditedId) {
                sendDataToParent({ type: 'polygon-deleted', polygonDeletedId: multiPolygonEditedId });
                // dispatch(setMultiPolygonEditedID(0));
            }

            sendDataToParent({
                type: 'layer-deleted',
                deletedLayerId: deletedLayerIDs[0],
                isDeleteAllClicked: deletedLayerIDs.length > 1,
            });

            dispatch(updatePolylineDistanceTooltipCoords(deletedLayerIDs));
            dispatch(setSquareGridCoordinates(null));
            dispatch(setGridRegionPolygonCoords(null));
            dispatch(earthEngineAreaOfInterestPolygonCoords(undefined));
        },
    };
};
// Object.values(_layers).map(({ _leaflet_id }) => {
//     setMapLayersData((layers) => layers.filter((layer) => layer.id !== _leaflet_id));
// });
